import styled from "@emotion/styled";

export const Pad = styled.div<{ bottom?: boolean }>`
  padding: 0 var(--space-md)
    ${({ bottom }): string =>
      bottom
        ? "padding-bottom: calc(var(--space-lg) + var(--safe-area-inset-bottom, 0px))"
        : ""};
`;
